import React from "react";
import "../App.css";
import { Link } from "react-router-dom";
import { SignUp } from "@clerk/clerk-react";

const clerkAppearance = {
  variables: {
    colorPrimary: "#007bff",
    colorText: "white",
    colorBackground: "#2a2a2a",
    colorInputBackground: "#333",
    colorInputText: "white",
  },
  elements: {
    card: {
      backgroundColor: "#2a2a2a",
      border: "1px solid #444",
      borderRadius: "15px",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
    },
    headerTitle: {
      color: "white",
    },
    headerSubtitle: {
      color: "#ccc",
    },
    socialButtonsBlockButton: {
      backgroundColor: "#333",
      border: "1px solid #444",
      "&:hover": {
        backgroundColor: "#444",
      },
    },
    socialButtonsBlockButtonText: {
      color: "white",
    },
    dividerLine: {
      backgroundColor: "#444",
    },
    dividerText: {
      color: "#888",
    },
    formFieldLabel: {
      color: "#ccc",
    },
    formFieldInput: {
      backgroundColor: "#333",
      border: "1px solid #555",
      color: "white",
    },
    footerActionText: {
      color: "#888",
    },
    footerActionLink: {
      color: "#007bff",
      "&:hover": {
        color: "#0056b3",
      },
    },
    identityPreviewText: {
      color: "white",
    },
    identityPreviewEditButtonIcon: {
      color: "#007bff",
    },
  },
};

const Register = () => {
  return (
    <div className="main-content-wrapper fade-in-up">
      <div className="top-left-fixed">
        <Link to="/" className="action-button-blue">Home</Link>
      </div>
      
      <h1 className="aharoni-style" style={{ fontSize: '2.5em', marginBottom: '40px' }}>Instructeur Registratie</h1>
      
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <SignUp routing="hash" appearance={clerkAppearance} forceRedirectUrl="/admin/login" />
      </div>
      
      <div className="admin-card" style={{ width: '100%', maxWidth: '500px', padding: '20px', marginTop: '20px', textAlign: 'center' }}>
        <div style={{ borderTop: '1px solid #333', paddingTop: '20px', width: '100%' }}>
          <p style={{ color: '#888', marginBottom: '10px' }}>Heeft u al een account?</p>
          <Link to="/admin/login" className="register-link" style={{ fontSize: '1.1em', fontWeight: 'bold' }}>
            Terug naar Inloggen
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
